import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, fmtRange } from "@/lib/api";
import Calendar from "@/components/Calendar";

const STAT = { confirmed: "مؤكد", approved: "بانتظار العربون", receipt_uploaded: "مراجعة الوصل" };

export default function CalendarView() {
  const { data: venues } = useQuery({ queryKey: ["admin-venues"], queryFn: async () => (await api.get("/admin/venues")).data });
  const [venueId, setVenueId] = useState(null);
  const [day, setDay] = useState(null);
  useEffect(() => { if (venues?.length && !venueId) setVenueId(venues[0].id); }, [venues, venueId]);

  const { data: dayBookings } = useQuery({
    queryKey: ["day-bookings", venueId, day],
    queryFn: async () => (await api.get("/admin/day-bookings", { params: { venue_id: venueId, date: day } })).data,
    enabled: !!(venueId && day),
    refetchInterval: 5000,
  });

  return (
    <div className="space-y-5" data-testid="calendar-view">
      <h1 className="font-display text-2xl">التقويم</h1>
      <div className="flex gap-2">
        {(venues || []).map((v) => (
          <button key={v.id} data-testid={`venue-tab-${v.id}`} onClick={() => { setVenueId(v.id); setDay(null); }}
            className={`px-5 py-2.5 rounded-full text-sm transition-colors ${venueId === v.id ? "btn-gold" : "card-lux text-muted2 hover:text-offwhite"}`}>
            {v.name}{!v.visible && " (مخفي)"}
          </button>
        ))}
      </div>
      {venueId && <Calendar venueId={venueId} selectedDate={day} onSelect={setDay} />}
      {day && (
        <div className="card-lux p-4" data-testid="day-bookings">
          <h2 className="text-sm text-gold mb-3">حفلات يوم {day}</h2>
          {dayBookings?.length ? dayBookings.map((b) => (
            <div key={b.id} className="flex items-center justify-between py-2.5 border-b border-gold/10 last:border-0">
              <div>
                <p className="text-offwhite text-sm">{b.name} · {b.event_type}</p>
                <p className="text-xs gold-text">{fmtRange(b.start_time, b.end_time)}</p>
              </div>
              <span className="text-[11px] text-muted2">{STAT[b.status] || b.status}</span>
            </div>
          )) : <p className="text-muted2/60 text-sm">لا حفلات في هذا اليوم — متاح للحجز.</p>}
        </div>
      )}
      <p className="text-xs text-muted2 text-center">يصبح اليوم محجوزًا (أحمر) عند اكتمال حفلتين مؤكدتين فيه. اضغط على أي يوم لعرض حفلاته وأوقاتها.</p>
    </div>
  );
}
